// extracted by mini-css-extract-plugin
export var growableInput = "_5l-0";
export var tagContainer = "_5l-2";
export var textInput = "_5l-1";